module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circular"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router
    }
  }, [_c('img', {
    staticClass: "contained",
    attrs: {
      "src": _vm.imgurl,
      "alt": _vm.alt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gt-xs overlay"
  }, [_c('h3', [_vm._v(_vm._s(_vm.caption))])]), _vm._v(" "), _c('div', {
    staticClass: "lt-sm overlay-mobile"
  }, [_c('h4', [_vm._v(_vm._s(_vm.caption))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54fcd987","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircularImage.vue
// module id = 21
// module chunks = 0